import { ReactElement } from 'react';
import { useParams } from 'react-router-dom';
import SessionErrorScreen from '../components/SelfService/SessionErrorScreen';
import SelfService from '../components/SelfService/SelfService';

export function SelfServicePage(): ReactElement {
  const { jobsiteId, sessionId } = useParams<{ jobsiteId: string; sessionId: string }>();

  if (!jobsiteId || !sessionId) {
    return <SessionErrorScreen />;
  }

  return <SelfService jobsiteId={jobsiteId} sessionId={sessionId} />;
}
